import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { api, formatApiError } from "../../lib/api";
import { Switch } from "../../components/ui/switch";
import StatusChip from "../../components/StatusChip";
import { toast } from "sonner";

export default function FeatureFlagsAdmin() {
  const [flags, setFlags] = useState([]);
  const load = async () => setFlags((await api.get("/feature-flags")).data);
  useEffect(() => { load(); }, []);

  const toggle = async (f) => {
    try {
      await api.patch(`/feature-flags/${f.key}`, { enabled: !f.enabled });
      toast.success(`${f.key} → ${!f.enabled ? "ON" : "OFF"}`);
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <AppShell title="Platform Feature Flags" subtitle={`${flags.length} flag(s) · Phase 1 defaults enforced`}>
      <div className="bg-white border border-erf-borderCream rounded-md overflow-x-auto">
        <table className="w-full erf-table">
          <thead className="bg-erf-creamSecondary">
            <tr>
              <th className="text-left px-3 py-2">Key</th>
              <th className="text-left px-3 py-2">Phase</th>
              <th className="text-left px-3 py-2">State</th>
              <th className="text-left px-3 py-2">Enabled</th>
            </tr>
          </thead>
          <tbody>
            {flags.map((f) => (
              <tr key={f.key} className="border-t border-erf-borderCream/60" data-testid={`flag-row-${f.key}`}>
                <td className="px-3 py-2 mono">{f.key}</td>
                <td className="px-3 py-2 mono">P{f.phase}</td>
                <td className="px-3 py-2">
                  {f.enabled ? <StatusChip status="connected" label="ENABLED" /> :
                    (f.phase > 1 ? <StatusChip status="phase_n" phase={f.phase} /> : <StatusChip status="not_configured" label="Disabled" />)}
                </td>
                <td className="px-3 py-2">
                  <Switch
                    checked={f.enabled}
                    onCheckedChange={() => toggle(f)}
                    data-testid={`flag-toggle-${f.key}`}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AppShell>
  );
}
